import moment from "moment";
import Parse from "parse";
import React from "react";
import {
  Offer,
  useRideSearchDate,
  useRideSearchEnd,
  useRideSearchStart,
  useRideSearchTime,
} from "..";

export function useRideSearch() {
  const [state, setState] = React.useState([]);

  const [start] = useRideSearchStart();
  const [end] = useRideSearchEnd();
  const [time] = useRideSearchTime();
  const [date] = useRideSearchDate();

  React.useEffect(() => {
    if (start && end) {
      fetchOffers({
        start_latitude: start.get("location").latitude,
        start_longitude: start.get("location").longitude,
        end_latitude: end.get("location").latitude,
        end_longitude: end.get("location").longitude,
        weekday: moment(date).weekday(),
        time,
        date,
      }).then(
        (result) => {
          setState(result);
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [start, end]);

  return state;
}

async function fetchOffers(params) {
  const result = await Parse.Cloud.run("rsSearch", params);

  const offers = result.offers.map((id) =>
    Offer.createWithoutData(id)
  );

  await Offer.fetchAll(offers, {});

  for (const offer of offers) {
    const user = offer.get("user");

    await user.fetch();

    const profile = user.get("rsProfile");

    await profile.fetch();
  }

  return offers;
}
